// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @global-style: true; */
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* .Navbar{
  @navbar-bg: var(--light-1);
} */
.bubble-container {
  position: relative;

  display: flex;

  align-items: flex-start;
}
/* EDIT BUTTON CSS */
.edit-button {
  color: black;
  border: none;
  padding: 0px 5px;
  border-radius: 4px;
  cursor: pointer;
  left: 194px;
  transform: translateY(-25%);
  position: absolute;
}


/* tooltip settings 👇 */

/* COPY BUTTON CSS */
/* tooltip settings 👇 */

.copy {
  /* button */
  --button-bg: #353434;
  --button-hover-bg: #006ac7 
  --button-text-color: #cccccc;
  --button-hover-text-color: #212529;
  --button-border-radius: 10px;
  --button-diameter: 30px;
  --button-outline-width: 1px;
  --button-outline-color: rgb(141, 141, 141);
  /* tooltip */
  --tooltip-bg: #f4f3f3;
  --toolptip-border-radius: 4px;
  --tooltip-font-family: Menlo, Roboto Mono, monospace;
  /* 👆 this field should not be empty */
  --tooltip-font-size: 12px;
  /* 👆 this field should not be empty */
  --tootip-text-color: rgb(50, 50, 50);
  --tooltip-padding-x: 7px;
  --tooltip-padding-y: 7px;
  --tooltip-offset: 8px;
  /* --tooltip-transition-duration: 0.3s; */
  /* 👆 if you need a transition, 
  just remove the comment,
  but I didn't like the transition :| */
}
SE
.Btn--primary:not(.Btn--outline) {

  background: #4285f4 !important;
  
  bottom: auto;
  
  text-shadow: black;
  
  right: 20px;
  
  }

.copy {
  box-sizing: border-box;
  width: var(--button-diameter);
  height: var(--button-diameter);
  border-radius: var(--button-border-radius);
  background-color: var(--gray-6);
  color: #212529;
  border: none;
  cursor: pointer;
  outline: none;
  position: absolute;
  top: -30px;
  left: 5px;
}

.tooltip {
  position: absolute;
  opacity: 0;
  visibility: 0;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font: var(--tooltip-font-size) var(--tooltip-font-family);
  color: var(--tootip-text-color);
  background: var(--tooltip-bg);
  padding: var(--tooltip-padding-y) var(--tooltip-padding-x);
  border-radius: var(--toolptip-border-radius);
  pointer-events: none;
  transition: all var(--tooltip-transition-duration)
    cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.tooltip::before {
  content: attr(data-text-initial);
}

.tooltip::after {
  content: "";
  position: absolute;
  bottom: calc(var(--tooltip-padding-y) / 2 * -1);
  width: var(--tooltip-padding-y);
  height: var(--tooltip-padding-y);
  background: inherit;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  z-index: -999;
  pointer-events: none;
}

.copy svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.checkmark {
  display: none;
}
.copy.copied .checkmark {
  display: block;
}

/* actions */

.copy:hover .tooltip,
.copy:focus:not(:focus-visible) .tooltip {
  opacity: 1;
  visibility: visible;
  top: calc((100% + var(--tooltip-offset)) * -1);
}

.copy:focus:not(:focus-visible) .tooltip::before {
  content: attr(data-text-end);
}

.copy:focus:not(:focus-visible) .clipboard {
  display: none;
}

.copy:focus:not(:focus-visible) .checkmark {
  display: block;
}

.copy:hover,
.copy:focus {
  background-color: var(--button-hover-bg);
}

.copy:active {
  outline: var(--button-outline-width) solid var(--button-outline-color);
}

.copy:hover svg {
  color: var(--button-hover-text-color);
}

/* Setting minimum height for the chat box */
.MessageContainer {
  min-height: 86vh;
}
/* SCROLL UP-Down buttons */
/* Sccroll-down */
.hbSPjO {
  top: 50% !important;
  background-color: #ffff !important;
  color: #006ac7 !important;
  margin-right: 50px;
}
/* Scroll-Up */
.bKZErM {
  bottom: 50% !important;
  background-color: #ffff !important;
  color: #006ac7 !important;
  margin-right: 50px;
}
.vCceY {

position: fixed;

top: 50%;

right: 30px;

background-color: #ffff;

color: #006ac7;

border: none;

border-radius: 50%;

width: 40px;

height: 40px;

} 
.fCTIqo {

  position: fixed;
  
  bottom: 50%;
  
  right: 30px;
  
  background-color: #ffff;
  
  color: #006ac7;
  
  border: none;
  
  border-radius: 50%;
  
  width: 40px;
  
  height: 40px;
  
  }

/* Thumbs up/down feedback modal  */
.feedback-error-message {
  color: red; /* Set the text color to red */
}

/* Styling for the FeedbackModalForm buttons */

.negative-feedback-buttons {
display: flex; /* Use flexbox */
justify-content: space-between; /* Space evenly between the buttons */
margin-top: 20px; /* Add some top margin */

}



.negative-feedback-close {
flex: 1 1; /* Distribute remaining space to the "Close" button */
margin-left: 20px; /* Add some right margin to create a gap */

}



.negative-feedback-submit {
flex: 1 1;
margin-left: 10px;/* Distribute remaining space to the "Submit Negative Feedback" button */
}




.feedback-modal .modal-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* Add some spacing and padding */
.feedback-modal .modal-content {
  padding: 20px;
}

/* Style the form inputs */
.feedback-modal input[type="text"],
.feedback-modal input[type="email"] {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Style the submit button */
.feedback-modal button[type="submit"] {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.feedback-modal button[type="submit"]:hover {
  background-color: #0056b3;
}

/* Add some spacing to the top of the modal */
.feedback-modal .modal-content {
  margin-top: 20px;
}

/* Center the modal title */
.feedback-modal .modal-title {
  text-align: center;
}

/* Style the close button */
.feedback-modal .modal-header .close {
  padding: 8px;
  margin: -8px;
}

/* Style the form labels */
.feedback-modal .modal-body label {
  font-weight: bold;
}

/* Style the form labels for required fields */
.feedback-modal .modal-body label[for="formCountry"]::after {
  content: " *";
  color: red;
}

/* Add spacing between form groups */
.feedback-modal .modal-body .form-group {
  margin-bottom: 15px;
}
.Message.right .Bubble {
  background: var(--brand-3);
  border-radius: 12px;
  margin-left: 14.5rem;
}
/* OVERALLFEEDBACK BUTTON */
  .feedback-button-container {
    position: fixed;
    top: 55px;
    right: 20px;
    z-index: 1000;
    min-height: 40px;
    min-width: 40px;
    height: 70px;
    width: 70px;
  }
 
  /* .feedback-button:hover::before {
    content: "Provide Feedback";
    color: black;
    border-radius: 15px;
    white-space: nowrap;
    font-size: 14px;
    pointer-events: none;
    text-decoration: none; 
  } */


  /* Cancel button and Submit button for overall feedback form */
  .cancel-button {
    margin-top: 20px;
  }
  .submit-button{
    margin-top: 20px;
    margin-right: 10px;
  }

  /* EDIT FEATURES */
  .edit-container {
    background-color: #f7f7f7;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
    
  }
  
  .edit-textarea {
    width: 100%;
    max-width: 300px; /* Limit the width to a reasonable value */
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 8px;
    font-size: 16px;
    resize: none;
    margin-bottom: 10px;
  }

  
  .editCancel {
    background-color: #ccc;
    padding: 6px 6px;
    border: none;
    border-radius: 2px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-right: 5px;
  }
  
  .editSubmit{
    background-color: #2196f3;
    color: white;
    padding: 6px 6px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-right: 3px;
  }
  .editSubmit:hover {
    background-color: #0f85db;
  }
  .editCancel:hover {
    background-color: #aaa;
  }

 
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;;GAEG;AACH;EACE,kBAAkB;;EAElB,aAAa;;EAEb,uBAAuB;AACzB;AACA,oBAAoB;AACpB;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;;;AAGA,wBAAwB;;AAExB,oBAAoB;AACpB,wBAAwB;;AAExB;EACE,WAAW;EACX,oBAAoB;EACpB;8BAC4B;EAC5B,kCAAkC;EAClC,4BAA4B;EAC5B,uBAAuB;EACvB,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,oDAAoD;EACpD,sCAAsC;EACtC,yBAAyB;EACzB,sCAAsC;EACtC,oCAAoC;EACpC,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,yCAAyC;EACzC;;uCAEqC;AACvC;AACA;;;EAGE,8BAA8B;;EAE9B,YAAY;;EAEZ,kBAAkB;;EAElB,WAAW;;EAEX;;AAEF;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,0CAA0C;EAC1C,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,yDAAyD;EACzD,+BAA+B;EAC/B,6BAA6B;EAC7B,0DAA0D;EAC1D,4CAA4C;EAC5C,oBAAoB;EACpB;0CACwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+CAA+C;EAC/C,+BAA+B;EAC/B,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA,YAAY;;AAEZ;;EAEE,UAAU;EACV,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,qCAAqC;AACvC;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;AAClB;AACA,2BAA2B;AAC3B,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;AACpB;AACA,cAAc;AACd;EACE,sBAAsB;EACtB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;AAEA,eAAe;;AAEf,QAAQ;;AAER,WAAW;;AAEX,uBAAuB;;AAEvB,cAAc;;AAEd,YAAY;;AAEZ,kBAAkB;;AAElB,WAAW;;AAEX,YAAY;;AAEZ;AACA;;EAEE,eAAe;;EAEf,WAAW;;EAEX,WAAW;;EAEX,uBAAuB;;EAEvB,cAAc;;EAEd,YAAY;;EAEZ,kBAAkB;;EAElB,WAAW;;EAEX,YAAY;;EAEZ;;AAEF,mCAAmC;AACnC;EACE,UAAU,EAAE,8BAA8B;AAC5C;;AAEA,8CAA8C;;AAE9C;AACA,aAAa,EAAE,gBAAgB;AAC/B,8BAA8B,EAAE,qCAAqC;AACrE,gBAAgB,EAAE,wBAAwB;;AAE1C;;;;AAIA;AACA,SAAO,EAAE,qDAAqD;AAC9D,iBAAiB,EAAE,0CAA0C;;AAE7D;;;;AAIA;AACA,SAAO;AACP,iBAAiB,CAAC,wEAAwE;AAC1F;;;;;AAKA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;AACtB;AACA,2BAA2B;EACzB;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,WAAW;EACb;;EAEA;;;;;;;;KAQG;;;EAGH,8DAA8D;EAC9D;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;;EAE5C;;EAEA;IACE,WAAW;IACX,gBAAgB,EAAE,0CAA0C;IAC5D,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;;EAGA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB","sourcesContent":["/* @global-style: true; */\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* .Navbar{\n  @navbar-bg: var(--light-1);\n} */\n.bubble-container {\n  position: relative;\n\n  display: flex;\n\n  align-items: flex-start;\n}\n/* EDIT BUTTON CSS */\n.edit-button {\n  color: black;\n  border: none;\n  padding: 0px 5px;\n  border-radius: 4px;\n  cursor: pointer;\n  left: 194px;\n  transform: translateY(-25%);\n  position: absolute;\n}\n\n\n/* tooltip settings 👇 */\n\n/* COPY BUTTON CSS */\n/* tooltip settings 👇 */\n\n.copy {\n  /* button */\n  --button-bg: #353434;\n  --button-hover-bg: #006ac7 \n  --button-text-color: #cccccc;\n  --button-hover-text-color: #212529;\n  --button-border-radius: 10px;\n  --button-diameter: 30px;\n  --button-outline-width: 1px;\n  --button-outline-color: rgb(141, 141, 141);\n  /* tooltip */\n  --tooltip-bg: #f4f3f3;\n  --toolptip-border-radius: 4px;\n  --tooltip-font-family: Menlo, Roboto Mono, monospace;\n  /* 👆 this field should not be empty */\n  --tooltip-font-size: 12px;\n  /* 👆 this field should not be empty */\n  --tootip-text-color: rgb(50, 50, 50);\n  --tooltip-padding-x: 7px;\n  --tooltip-padding-y: 7px;\n  --tooltip-offset: 8px;\n  /* --tooltip-transition-duration: 0.3s; */\n  /* 👆 if you need a transition, \n  just remove the comment,\n  but I didn't like the transition :| */\n}\nSE\n.Btn--primary:not(.Btn--outline) {\n\n  background: #4285f4 !important;\n  \n  bottom: auto;\n  \n  text-shadow: black;\n  \n  right: 20px;\n  \n  }\n\n.copy {\n  box-sizing: border-box;\n  width: var(--button-diameter);\n  height: var(--button-diameter);\n  border-radius: var(--button-border-radius);\n  background-color: var(--gray-6);\n  color: #212529;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  position: absolute;\n  top: -30px;\n  left: 5px;\n}\n\n.tooltip {\n  position: absolute;\n  opacity: 0;\n  visibility: 0;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  font: var(--tooltip-font-size) var(--tooltip-font-family);\n  color: var(--tootip-text-color);\n  background: var(--tooltip-bg);\n  padding: var(--tooltip-padding-y) var(--tooltip-padding-x);\n  border-radius: var(--toolptip-border-radius);\n  pointer-events: none;\n  transition: all var(--tooltip-transition-duration)\n    cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.tooltip::before {\n  content: attr(data-text-initial);\n}\n\n.tooltip::after {\n  content: \"\";\n  position: absolute;\n  bottom: calc(var(--tooltip-padding-y) / 2 * -1);\n  width: var(--tooltip-padding-y);\n  height: var(--tooltip-padding-y);\n  background: inherit;\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n  z-index: -999;\n  pointer-events: none;\n}\n\n.copy svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.checkmark {\n  display: none;\n}\n.copy.copied .checkmark {\n  display: block;\n}\n\n/* actions */\n\n.copy:hover .tooltip,\n.copy:focus:not(:focus-visible) .tooltip {\n  opacity: 1;\n  visibility: visible;\n  top: calc((100% + var(--tooltip-offset)) * -1);\n}\n\n.copy:focus:not(:focus-visible) .tooltip::before {\n  content: attr(data-text-end);\n}\n\n.copy:focus:not(:focus-visible) .clipboard {\n  display: none;\n}\n\n.copy:focus:not(:focus-visible) .checkmark {\n  display: block;\n}\n\n.copy:hover,\n.copy:focus {\n  background-color: var(--button-hover-bg);\n}\n\n.copy:active {\n  outline: var(--button-outline-width) solid var(--button-outline-color);\n}\n\n.copy:hover svg {\n  color: var(--button-hover-text-color);\n}\n\n/* Setting minimum height for the chat box */\n.MessageContainer {\n  min-height: 86vh;\n}\n/* SCROLL UP-Down buttons */\n/* Sccroll-down */\n.hbSPjO {\n  top: 50% !important;\n  background-color: #ffff !important;\n  color: #006ac7 !important;\n  margin-right: 50px;\n}\n/* Scroll-Up */\n.bKZErM {\n  bottom: 50% !important;\n  background-color: #ffff !important;\n  color: #006ac7 !important;\n  margin-right: 50px;\n}\n.vCceY {\n\nposition: fixed;\n\ntop: 50%;\n\nright: 30px;\n\nbackground-color: #ffff;\n\ncolor: #006ac7;\n\nborder: none;\n\nborder-radius: 50%;\n\nwidth: 40px;\n\nheight: 40px;\n\n} \n.fCTIqo {\n\n  position: fixed;\n  \n  bottom: 50%;\n  \n  right: 30px;\n  \n  background-color: #ffff;\n  \n  color: #006ac7;\n  \n  border: none;\n  \n  border-radius: 50%;\n  \n  width: 40px;\n  \n  height: 40px;\n  \n  }\n\n/* Thumbs up/down feedback modal  */\n.feedback-error-message {\n  color: red; /* Set the text color to red */\n}\n\n/* Styling for the FeedbackModalForm buttons */\n\n.negative-feedback-buttons {\ndisplay: flex; /* Use flexbox */\njustify-content: space-between; /* Space evenly between the buttons */\nmargin-top: 20px; /* Add some top margin */\n\n}\n\n\n\n.negative-feedback-close {\nflex: 1; /* Distribute remaining space to the \"Close\" button */\nmargin-left: 20px; /* Add some right margin to create a gap */\n\n}\n\n\n\n.negative-feedback-submit {\nflex: 1;\nmargin-left: 10px;/* Distribute remaining space to the \"Submit Negative Feedback\" button */\n}\n\n\n\n\n.feedback-modal .modal-dialog {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n/* Add some spacing and padding */\n.feedback-modal .modal-content {\n  padding: 20px;\n}\n\n/* Style the form inputs */\n.feedback-modal input[type=\"text\"],\n.feedback-modal input[type=\"email\"] {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n/* Style the submit button */\n.feedback-modal button[type=\"submit\"] {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.feedback-modal button[type=\"submit\"]:hover {\n  background-color: #0056b3;\n}\n\n/* Add some spacing to the top of the modal */\n.feedback-modal .modal-content {\n  margin-top: 20px;\n}\n\n/* Center the modal title */\n.feedback-modal .modal-title {\n  text-align: center;\n}\n\n/* Style the close button */\n.feedback-modal .modal-header .close {\n  padding: 8px;\n  margin: -8px;\n}\n\n/* Style the form labels */\n.feedback-modal .modal-body label {\n  font-weight: bold;\n}\n\n/* Style the form labels for required fields */\n.feedback-modal .modal-body label[for=\"formCountry\"]::after {\n  content: \" *\";\n  color: red;\n}\n\n/* Add spacing between form groups */\n.feedback-modal .modal-body .form-group {\n  margin-bottom: 15px;\n}\n.Message.right .Bubble {\n  background: var(--brand-3);\n  border-radius: 12px;\n  margin-left: 14.5rem;\n}\n/* OVERALLFEEDBACK BUTTON */\n  .feedback-button-container {\n    position: fixed;\n    top: 55px;\n    right: 20px;\n    z-index: 1000;\n    min-height: 40px;\n    min-width: 40px;\n    height: 70px;\n    width: 70px;\n  }\n \n  /* .feedback-button:hover::before {\n    content: \"Provide Feedback\";\n    color: black;\n    border-radius: 15px;\n    white-space: nowrap;\n    font-size: 14px;\n    pointer-events: none;\n    text-decoration: none; \n  } */\n\n\n  /* Cancel button and Submit button for overall feedback form */\n  .cancel-button {\n    margin-top: 20px;\n  }\n  .submit-button{\n    margin-top: 20px;\n    margin-right: 10px;\n  }\n\n  /* EDIT FEATURES */\n  .edit-container {\n    background-color: #f7f7f7;\n    border-radius: 10px;\n    padding: 10px;\n    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);\n    \n  }\n  \n  .edit-textarea {\n    width: 100%;\n    max-width: 300px; /* Limit the width to a reasonable value */\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 8px;\n    font-size: 16px;\n    resize: none;\n    margin-bottom: 10px;\n  }\n\n  \n  .editCancel {\n    background-color: #ccc;\n    padding: 6px 6px;\n    border: none;\n    border-radius: 2px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-right: 5px;\n  }\n  \n  .editSubmit{\n    background-color: #2196f3;\n    color: white;\n    padding: 6px 6px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-right: 3px;\n  }\n  .editSubmit:hover {\n    background-color: #0f85db;\n  }\n  .editCancel:hover {\n    background-color: #aaa;\n  }\n\n \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
